import { getImgeUrl } from 'src/environments/environment';
import { CommonModule, NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginationComponent } from 'src/app/admin/pagination/pagination.component';
import { AdminUserService } from 'src/app/admin/components/admin-user/admin-user.service';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';

@Component({
  selector: 'app-article-list',
  standalone: true,
  imports: [NgFor, RouterModule, ReactiveFormsModule, PaginationComponent, CommonModule],
  templateUrl: './article-list.component.html',
  styleUrl: './article-list.component.scss'
})
export class ArticleListComponent {

  articles
  filter_form: FormGroup
  language = 1
  languages:any
  page = 1
  number_of_page = 1
  paginatedData: any[];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number;
  totalPages
  article_types: any
  imageUrl = getImgeUrl()
  filter:any = {
    "title": "", 
    "author": "",
    "article_type":0,
    "page": 1, 
    "lang": this.language
  }
  isToggled = false;

  type
  constructor(private userService: AdminUserService, private toaster: ToastrService,
    private adminService: AdminService,
    private formBuilder: FormBuilder,
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute
  ) {
    this.itemsPerPage = this.adminService.ITEM_PERPAGE
    this.themeService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });

    // this.type = this.activeRouter.snapshot.params["type"]

  }

	

  toggleTheme() {
      this.themeService.toggleTheme();
  }


  ngOnInit(): void {

    this.createFilterForm()
    this.getLanguage()
    this.activeRouter.paramMap.subscribe(params => {
      this.type = params.get('type');
      this.getArticleType()
    });

    // this.getArticleType()
  }

  getData() {
    if (this.type) {
      this.article_types.forEach(tp => {
        if (tp.type_name.toLowerCase() == this.type.toLowerCase()) {
          this.filter_form.get("article_type").setValue(tp.id)
        } 
      });
      this.applyFilter()

    } else {
      this.getArticles()
    }
  }
  getLanguage() {
    this.languages = this.adminService.getWebsiteLanguages()
  }

  getArticleType() {
    this.adminService.getArticleType().subscribe({
      next: (res) => {
        this.article_types = res
        this.getData()
      }
    })
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.filter["page"] = page
    this.getArticles();
  }


  createFilterForm() {
    this.filter_form = this.formBuilder.group({
      title: ["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      author: ["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      article_type:["", Validators.pattern(/^[a-zA-Z0-9]*$/)],
      content_language: ['', Validators.pattern(/^[a-zA-Z0-9]*$/)],
    })
  }

  applyFilter() {
    if(this.filter_form.invalid) return 
    let lang = this.filter_form.get("content_language").value
    if (lang) {
      this.language = lang
    }
    const data = this.filter_form.value

    this.filter = {
      "title": data.title?data.title:"", 
      "author": data.author?data.author:"",
      "article_type": data.article_type? data.article_type:0,
      "page": 1, 
      "lang": this.language
    }

    

    this.getArticles()

    

  }

  resetFilter() {
    this.filter_form.reset()
    this.filter.title = " "
    this.filter.lang = 1
    this.filter.author = " "
    this.filter.article_type = 0
    this.getArticles()
  }
  getArticles() {
    this.adminService.getRecordList(this.adminService.ARTICLE_URL, this.filter).subscribe({
      next: (res) => {
        this.articles = res["data"]
        this.totalItems = res["total_records"]
        console.log("page", this.number_of_page)

      },
      error: (error) => {
        console.error("here goes the Unexpected error:", error);
      }
    })
  }

}
